module.exports = __webpack_public_path__ + "img/arrow.e660746c.svg";